'use client'

import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'app/i18n/client'
import ArrowDownIcon from 'public/icons/arrow-down.svg'

interface FormNightsSelectProps {
  control: Control<any>
  name?: string
}

const NIGHT_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9]

const FormNightsSelect: React.FunctionComponent<FormNightsSelectProps> = ({
  control,
  name = 'nights',
}) => {
  const { t } = useTranslation()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        // Mirrors SearchHotelForm's Select box structure (label sizing,
        // margins, value type scale) so both rows render the same height.
        <div className="border-gray-150 border border-l-2 border-l-primary p-3 h-full">
          <label className="block text-xxs lg:text-xs select-none text-gray-50 mb-2 lg:mb-3 uppercase">
            {t('Number of nights')}
          </label>
          <div className="relative">
            <select
              className="w-full pr-6 text-sm lg:text-lg bg-transparent text-gray-dark outline-none appearance-none cursor-pointer"
              value={field.value}
              onChange={(e) => field.onChange(Number(e.target.value))}
            >
              {NIGHT_OPTIONS.map((n) => (
                <option key={n} value={n}>
                  {t('{{n}} night(s)', { n })}
                </option>
              ))}
            </select>
            <ArrowDownIcon className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none text-primary fill-current" />
          </div>
        </div>
      )}
    />
  )
}

export default FormNightsSelect
